import { AxiosRequestConfig } from 'axios'
import { jwtDecode } from 'jwt-decode'

import { apiRoutes } from '@/config/api-routes'
import { usersApi } from '@/lib/axios'

export type Context = 'company' | 'team' | 'folder'
export type UserCompanyRole = 'admin' | 'owner' | 'member'

export async function getAccessToken<Permissions>(
  context: Context,
  context_id: number,
  options?: AxiosRequestConfig,
) {
  const {
    data: { token },
  } = await usersApi.get<{ token: string }>(apiRoutes.getAccessToken, {
    ...options,
    params: {
      context,
      context_id,
    },
  })

  type AccessTokenParsed = {
    exp: number
    permissions: string
    permissionsStruct: Permissions
    role: UserCompanyRole
  }

  const { permissionsStruct: permissions, role }: AccessTokenParsed =
    jwtDecode(token)

  return { accessToken: token, permissions, role }
}
